var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uploader-files"},[_vm._t("default",function(){return [_c('ul',_vm._l((_vm.files),function(file){return _c('li',{key:file.id},[_c('uploader-file',{attrs:{"file":file}})],1)}),0)]},{"files":_vm.files})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }